import React from "react";

import isIntuit from "Intuit/isIntuit";
import { EmployeeCostsTable } from "QuotePage/Components/EmployeeCosts";
import LoadingPlanCard from "QuotePage/Components/LoadingPlanCard";
import PlanCard from "QuotePage/Components/PlanCard";
import { CurrentPlanFakeButton, MoreDetailsButton } from "QuotePage/Components/PlanCardButtons";

import { Div } from "Common/HTML";

import { EnrolledEmployeesModalTrigger } from "./enrolledPlanCard/EnrolledEmployeesModal";
import EnrolledPolicyPlansLoader from "./EnrolledPolicyPlansLoader";

const EmployeeCostsSection = ({ plan }) => {
  const { employee_cost_breakdowns: employeeCostBreakdowns } = plan;

  const costsTableRows = employeeCostBreakdowns.slice(0, 2).map(({ name, age, employee_premium }) => ({
    name,
    age,
    cost: employee_premium,
  }));

  return (
    <>
      <EmployeeCostsTable rows={costsTableRows} />
      <Div py={isIntuit() ? 3 : 4} px={isIntuit() ? 2 : 3}>
        <EnrolledEmployeesModalTrigger plan={plan} />
      </Div>
    </>
  );
};

const EnrolledPlanCard = ({ enrolledPlan: plan }) => (
  <PlanCard planId={plan.id} plan={plan} employeeCostsSectionComponent={<EmployeeCostsSection plan={plan} />}>
    <MoreDetailsButton planId={plan.id} />
    <CurrentPlanFakeButton />
  </PlanCard>
);

const StatefulEnrolledPlanCard = () => (
  <EnrolledPolicyPlansLoader>
    {({ medicalPlans, isLoadingEnrolledPlans }) => {
      const enrolledPlan = medicalPlans?.[0];
      return enrolledPlan ? <EnrolledPlanCard enrolledPlan={enrolledPlan} /> : isLoadingEnrolledPlans ? <LoadingPlanCard /> : null;
    }}
  </EnrolledPolicyPlansLoader>
);

export default StatefulEnrolledPlanCard;
